import angular from "angular";

angular
    .module('app')
    .component('lessonCreateForm', {
        template: require('./lesson-create-form.html'),
        controller: ['$uibModal', 'Notifier', '$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($uibModal, Notifier, $http) {

    let $ctrl = this;

    $ctrl.id = null;
    $ctrl.title = null;
    $ctrl.chapterLessons = [];
    $ctrl.afterLesson = null;

    $ctrl.$onInit = function () {
        $ctrl.chapter = $ctrl.resolve.chapter;
        $ctrl.course = $ctrl.resolve.course;
        $ctrl.chapterLessons = $ctrl.chapter.lessons;
        $ctrl.afterLesson = $ctrl.chapterLessons[$ctrl.chapterLessons.length - 1];
    };


    $ctrl.submit = function () {

        if ($ctrl.loading) {
            return;
        }

        let params = {
            title: $ctrl.title,
            chapter_id: $ctrl.chapter.id,
            order: $ctrl.afterLesson ? ($ctrl.afterLesson.order + 1) : 0,
        };

        $ctrl.loading = true;

        $http
            .post(`/admin/courses/${$ctrl.course.id}/lessons`, params)
            .then(
                function (response) {
                    //window.location = `/admin/courses/${$ctrl.course.id}/lessons?lesson_id=${id}`;
                    $ctrl.close({
                        $value: {
                            id: response.data.lesson_id,
                            title: $ctrl.title,
                        }
                    });
                },
                function (error) {
                    $ctrl.loading = false;
                    alert(error);
                }
            )
    }
}
